import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Typography from '~/components/core/Atomic/Typography';
import useInterval from '~/components/hooks/useInterval';
import { useLoadingSpan } from '~/observability/useLoadingSpan';

import CardDialog from './CardDialog';
import LoadingIndicator from './LoadingIndicator';

function LoadingDialog({ isError, onClose, track, text, delay, __loadingSource }) {
  const [showLoading, setShowLoading] = useState(false);

  useInterval(() => setShowLoading(true), showLoading ? null : delay);

  // Span tracks the time the user actually sees the dialog, not mount time.
  // When `delay > 0`, the component is mounted but invisible until showLoading flips.
  const isVisible = !delay || delay <= 0 || showLoading;
  useLoadingSpan({ isLoading: isVisible, isError, loadingSpanName: track, __loadingSource });

  if (delay && delay > 0 && !showLoading) {
    return null;
  }

  return (
    <CardDialog isDialog trackAlt={`Loading (${track})`} noCardTitle onClose={onClose}>
      {text && <Typography variant="subtitle1">{text}</Typography>}
      <LoadingIndicator isError={isError} />
    </CardDialog>
  );
}

LoadingDialog.propTypes = {
  isError: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  text: PropTypes.string,
  track: PropTypes.string.isRequired,
  delay: PropTypes.number,
  // Auto-injected by babel-loading-source. Not for callers to pass.
  __loadingSource: PropTypes.shape({ fileName: PropTypes.string, lineNumber: PropTypes.number }),
};

export default LoadingDialog;
